import { ThemeContext } from "../../Contexts/ThemeContext";
import useScroll from "../../Hooks/useScroll";
import { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

const Makeup = ({showIcon}) => {
  const [linkOneHover, setLinkOneHover] = useState(false);
  const [scrollPosition] = useScroll();
  const [subMenuHover, setSubMenuHover] = useState(false);

  return (
    <div
      onMouseEnter={() => {
        setLinkOneHover(true)
        showIcon() 
      }}
      onMouseLeave={() => setLinkOneHover(false)}
      className={`transition-all ease-in-out min-h-[50px] duration-300 flex items-center ${
        scrollPosition > 80 ? "min-h-[65px]" : ""
      }`}
    >
      <p
        className={`mr-10 block font-bold cursor-pointer ${
          scrollPosition > 80
            ? "hover:text-accent text-secondary"
            : "text-secondary hover:text-accent"
        }`}
      >
        MAKEUP
        <FontAwesomeIcon
          className="w-3 ms-2"
          icon={faChevronDown}
        ></FontAwesomeIcon>
      </p>

      {/* Face Hover product-Category  */}

      <div
        className={`flex flex-col md:flex-row h-[100vh] md:h-auto absolute top-10 bg-white w-fit md:ml-[-200px] ${
          linkOneHover ? "block text-start" : "hidden relative"
        } text-black `}
      >
        {/* ........Face category......... */}
        <div className="px-10 py-10 pt-16 md:py-16">
          <p className="mb-6 text-black text-opacity-70">FACE</p>
          <Link
            to="/product-category/foundation"
            className=" hover:text-accent block"
          >
            Foundation
          </Link>
          <Link
            to="/product-category/blush on"
            className=" hover:text-accent block"
          >
            Blush On
          </Link>
          <Link
            to="/product-category/face powder"
            className=" hover:text-accent block"
          >
            Face Powder
          </Link>

          <Link
            to="/product-category/concealer"
            className=" hover:text-accent block"
          >
            Concealer
          </Link>

          <Link
            to="/product-category/primer"
            className=" hover:text-accent block"
          >
            Primer
          </Link>

          <Link
            to="/product-category/highlighter"
            className=" hover:text-accent block"
          >
            Contour/Highlighter
          </Link>

          <Link to="/product-category/gel" className=" hover:text-accent block">
            Gel/Cream
          </Link>

          <Link
            to="/product-category/fixer"
            className=" hover:text-accent block"
          >
            Fixer
          </Link>

          <Link
            to="/product-category/mask"
            className=" hover:text-accent block"
          >
            Mask
          </Link>

          <Link
            to="/product-category/tonic"
            className=" hover:text-accent block"
          >
            Tonic
          </Link>

          <Link
            to="/product-category/remover"
            className=" hover:text-accent block"
          >
            Cleaner/Remover
          </Link>
        </div>
        {/* ........Eye category......... */}
        <div className="px-10 py-10  md:py-16">
          <p className="mb-6 text-black text-opacity-70">EYES</p>
          <Link
            to={`/product-category/eye Liner`}
            className=" hover:text-accent block"
          >
            Eye Liner
          </Link>

          <Link
            to={`/product-category/eye Pencil`}
            className=" hover:text-accent block"
          >
            Eye Pencil
          </Link>
          <Link
            to={`/product-category/mascara`}
            className=" hover:text-accent block"
          >
            Mascara
          </Link>
          <Link
            to={`/product-category/eye Shadow`}
            className=" hover:text-accent block"
          >
            Eye Shadow
          </Link>
          <Link
            to={`/product-category/eye Primer`}
            className=" hover:text-accent block"
          >
            Eye Primer
          </Link>
          <Link
            to={`/product-category/pomade`}
            className=" hover:text-accent block"
          >
            Pomade
          </Link>
        </div>
        {/* ........Lips category......... */}
        <div className="px-10 py-10  md:py-16">
          <p className="mb-6 text-black text-opacity-70">LIPS</p>
          <Link
            to={`/product-category/lip care`}
            className=" hover:text-accent block"
          >
            Lip Care
          </Link>
          <Link
            to={`/product-category/lip gloss`}
            className=" hover:text-accent block"
          >
            Lip Gloss
          </Link>
          <Link
            to={`/product-category/lip pencil`}
            className=" hover:text-accent block"
          >
            Lip Pencil
          </Link>
          <Link
            to={`/product-category/lipstick`}
            className=" hover:text-accent block"
          >
            Lip Stick
          </Link>
        </div>
        {/* ........Nails category......... */}
        <div className="px-10 py-10  md:py-16 pb-[120px]">
          <p className="mb-6 text-black text-opacity-70">Nails</p>
          <Link
            to={`/product-category/nail polish`}
            className=" hover:text-accent block"
          >
            Nail Polish
          </Link>

          <Link
            to={`/product-category/nail enamel remover`}
            className=" hover:text-accent block"
          >
            Nail Polish Remover
          </Link>
          <Link
            to={`/product-category/nail care`}
            className=" hover:text-accent block"
          >
            Nail Care
          </Link>
          <Link
            to={`/product-category/nail fixer`}
            className=" hover:text-accent block"
          >
            Nail Fixer
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Makeup;
